onReady(($) => {
    $('.content-cards')
        .each((index, module) => {
            let $module = $(module)
            const $articles = $('.articles', $module)
            if ($articles.hasClass('one-upcoming-event') || $articles.hasClass('two-upcoming-events')) {
                return;
            }
            ;
            $('.articles', $module)
                .slick({
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: true,
                    dots: true,
                    prevArrow: $(".slick-prev", $module),
                    nextArrow: $(".slick-next", $module),
                    fade: false,
                    responsive: [
                        {
                            breakpoint: 841,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 564,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            $module.hover(function () {
                $('.slick-next, .slick-prev', $module)
                    .toggleClass("chevron-visible");
            });
        });
    const contentCards = Array.from(document.querySelectorAll('.content-cards'))
    for (const contentCard of contentCards) {
        const ctaButton = contentCard.querySelector('.cta-button')
        ctaButton && ctaButton.addEventListener('click', (event) => dataLayer.push({
            event: 'cta-click',
            interactionType: 'click',
            moduleName: contentCard.dataset.moduleName,
            elementContent: ctaButton.textContent.replace("\n", '')
                .trim(),
            elementType: event.target.nodeName,
            elementClasses: event.target.classList.toString(),
            destinationUrl: event.target.href,
            modulePosition: contentCard.dataset.modulePosition,
            distinctModulePosition: contentCard.dataset.distinctModulePosition,
            moduleTabPosition: contentCard.dataset.tabPosition,
            moduleId: contentCard.dataset.moduleId,
            wpLoggedIn: document.body.classList.contains('logged-in')
                .toString(),
        }))
    }
});
